import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { Heart } from "lucide-react";

const ValentineCountdown = () => {
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });

  useEffect(() => {
    const valentinesDay = new Date("2026-02-14T00:00:00");

    const updateCountdown = () => {
      const now = new Date();
      const diff = valentinesDay.getTime() - now.getTime();

      if (diff > 0) {
        setTimeLeft({
          days: Math.floor(diff / (1000 * 60 * 60 * 24)),
          hours: Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
          minutes: Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60)),
          seconds: Math.floor((diff % (1000 * 60)) / 1000),
        });
      } else {
        setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 });
      }
    };

    updateCountdown();
    const interval = setInterval(updateCountdown, 1000);
    return () => clearInterval(interval);
  }, []);

  const TimeUnit = ({ value, label }: { value: number; label: string }) => (
    <motion.div
      initial={{ scale: 0 }}
      animate={{ scale: 1 }}
      className="flex flex-col items-center"
    >
      <div className="relative">
        <div className="w-16 h-16 sm:w-20 sm:h-20 bg-gradient-to-br from-pink-500/20 to-red-500/20 rounded-xl flex items-center justify-center border border-pink-500/30 backdrop-blur-sm">
          <motion.span
            key={value}
            initial={{ y: -20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            className="text-2xl sm:text-3xl font-bold text-white"
          >
            {value.toString().padStart(2, "0")}
          </motion.span>
        </div>
        <Heart className="absolute -top-2 -right-2 w-4 h-4 text-pink-500 fill-pink-500" />
      </div>
      <span className="text-pink-300 text-xs sm:text-sm mt-2 uppercase tracking-wider">
        {label}
      </span>
    </motion.div>
  );

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.5 }}
      className="mt-8 p-6 rounded-2xl bg-white/5 backdrop-blur-sm border border-white/10"
    >
      <p className="text-pink-300 text-center mb-4">
        ⏰ Countdown to Valentine's Day 2026
      </p>
      <div className="flex justify-center gap-3 sm:gap-6">
        <TimeUnit value={timeLeft.days} label="Days" />
        <TimeUnit value={timeLeft.hours} label="Hours" />
        <TimeUnit value={timeLeft.minutes} label="Mins" />
        <TimeUnit value={timeLeft.seconds} label="Secs" />
      </div>
    </motion.div>
  );
};

export default ValentineCountdown;
